'use client';

import { usePathname } from 'next/navigation';
import { asText, RichTextField } from '@prismicio/client';
import { faCheckCircle, faGlobe } from '@fortawesome/pro-regular-svg-icons';

import { pathWithoutLocale } from '@preventx/prismic-services';
import { Box, Icon, List, Dropdown, ListItem } from '@preventx/oxygen';

// Contexts
import { useSiteContext } from '@/context/SiteProvider';

// Components
import { Link } from '@/components/Actions/Link';

type LocalesProps = {
  label: RichTextField;
};

export const Locales = ({ label }: LocalesProps) => {
  const pathname = usePathname();
  const { languages, language: currentLanguage } = useSiteContext();

  if (languages.length <= 1) {
    return null;
  }

  return (
    <Dropdown
      component="div"
      buttonVariant="icon"
      label={asText(label)}
      id="locale-selection"
      icon={{ definition: faGlobe, position: 'icon-only' }}
    >
      <List style="stack-nav" component="ul">
        {languages.map(({ label, localeIsoCode, languageIsoCode }, index) => {
          const path = pathWithoutLocale(pathname);
          const languageCode = `${languageIsoCode}-${localeIsoCode}`;

          return (
            <ListItem key={`${languageCode}-${index + 1}`}>
              <Link
                type="link"
                as="default"
                retainSearchParams
                href={`/${languageCode}/${path}`}
              >
                <Box component="span" addCluster>
                  <Box component="span">{languageIsoCode}</Box>
                  <Box component="span">{label}</Box>

                  {currentLanguage === languageCode && (
                    <Box component="span" fontColour="t-positive">
                      <Icon icon={faCheckCircle} />
                    </Box>
                  )}
                </Box>
              </Link>
            </ListItem>
          );
        })}
      </List>
    </Dropdown>
  );
};
